import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles.js';

const ProvidersPage = lazy(() => import('./ProvidersPage'));

const ProvidersConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.ServiceConfig,
  routes: [
    {
      path: 'providers',
      element: <ProvidersPage />,
    },
  ],
};

export default ProvidersConfig;
